import { render, staticRenderFns } from "./PublicAgencies.vue?vue&type=template&id=65ec318e&"
import script from "./PublicAgencies.vue?vue&type=script&lang=js&"
export * from "./PublicAgencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports